import axios from 'axios'

function getResponse(response) {
  const isJson = response.headers['content-type'] === 'application/json'
  return isJson ? response.data.data : response.data
}

export default {

  async get(action, { query = {}, config = {} } = {}) {
    const response = await axios.get(action, {
      params: query,
      ...config
    })
    return getResponse(response)
  },

  async post(action, data, query = {}) {
    const response = await axios.post(action, data, {
      params: query
    })
    return getResponse(response)
  },

  async update(action, data, query = {}) {
    const response = await axios.patch(action, data, {
      params: query
    })
    return response.data.data
  }

}
